import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  Output,
  SimpleChanges,
} from '@angular/core';

import * as _moment from 'moment-timezone';

import { getDefaultTimezone } from '@recruitee/utils';

import { ConnectedOverlayDirective } from '../../core/overlay/overlay-directives';
import { ConnectionPositionPair } from './../../core/overlay/position/connected-position';

const moment = _moment;

@Component({
  selector: 'rt-time-zone-picker',
  templateUrl: 'time-zone-picker.component.html',
  styleUrls: ['./time-zone-picker.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.has-font-weight-normal]': 'hasFontWeightNormal',
    '[class.has-color-default]': 'hasColorDefault',
    '[class.has-font-size-default]': 'hasFontSizeDefault',
  },
})
export class TimeZonePickerComponent {
  @Input() public short: boolean = false;
  @Input() public timezone: string;
  @Input() public emit: boolean = false;
  @Input() public underlinedVariant: boolean = false;
  @Input() public hasMargin: boolean = true;
  @Input() public dropdownIconHasMargin: boolean = true;
  @Input() public hasFontWeightNormal: boolean = false;
  @Input() public hasColorDefault: boolean = false;
  @Input() public hasFontSizeDefault: boolean = false;
  @Input() public dropdown: boolean = false;
  @Input() public positions: ConnectionPositionPair[] = [];

  @Output() public zoneChange: EventEmitter<string> = new EventEmitter();

  public timeZoneString: string;

  private currentTimeZone: string;

  constructor(private cdRef: ChangeDetectorRef) {}

  public ngOnInit(): void {
    if (this.emit) {
      this.onZoneSelect(this.timezone || this.defaultTimezone());
    } else {
      this.setZone(this.timezone || this.defaultTimezone());
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    const { timezone } = changes;

    if (timezone && !timezone.firstChange) {
      this.setZone(this.timezone);
    }
  }

  public toggle(timezoneDropdown: ConnectedOverlayDirective): void {
    if (timezoneDropdown) {
      timezoneDropdown.open = !timezoneDropdown.open;
      this.cdRef.detectChanges();
    }
  }

  public onZoneSelect(zone: string, timezoneDropdown?: any): void {
    this.toggle(timezoneDropdown);
    this.setZone(zone);
    this.zoneChange.emit(zone);
  }

  private setZone(zone: string): void {
    this.currentTimeZone = zone;
    this.setTimeZoneString();
  }

  private defaultTimezone(): string {
    return getDefaultTimezone();
  }

  private setTimeZoneString(): void {
    const date = moment.tz(this.currentTimeZone);

    this.timeZoneString = this.short
      ? date.format('z')
      : `${this.currentTimeZone} GMT${date.format('Z')}`;
    this.cdRef.detectChanges();
  }
}
